import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import React from 'react';
import { TFunction } from 'react-i18next';
import productImagePlaceholder from 'common/assets/product-placeholder.png';
import { Stack, Avatar, Typography } from '@mui/material';
import { CategoriesTableRow } from './rows';

interface CategoriesTableColDef extends GridColDef {
	field: keyof CategoriesTableRow;
	renderCell?: (params: GridRenderCellParams<any, CategoriesTableRow>) => React.ReactNode;
}

export const getCategoriesTableColumns = (deps: { t: TFunction }) => {
	const { t } = deps;

	const columns: CategoriesTableColDef[] = [
		{
			field: 'name',
			headerName: t('category.category', 'Category'),
			renderCell: ({ row }) => {
				return (
					<Stack direction="row" alignItems="center">
						<Avatar
							src={row.image || productImagePlaceholder}
							alt={row.name}
							sx={{ width: 80, height: 80 }}
							imgProps={{
								style: {
									objectFit: 'contain',
								},
							}}
							variant="square"
						/>
						<Typography sx={{ ml: 2, fontSize: '1.4rem', fontWeight: 500 }}>{row.name}</Typography>
					</Stack>
				);
			},
			minWidth: 400,
		},
		{
			field: 'description',
			headerName: t('common:form.description', 'Description'),
			minWidth: 400,
			flex: 1,
		},
		{
			field: 'productCount',
			headerName: t('common:products.products', 'Products'),
			minWidth: 150,
		},
		{
			field: 'orderIndex',
			headerName: t('category.displayOrder', 'Display order'),
			minWidth: 250,
		},
	];

	return columns;
};
